module.exports = __webpack_public_path__ + "static/img/rewards_pop_up@2x.20d317df.png";